import React from "react";
import { Box, Paper, Typography } from "@mui/material";

export default function WeekOverviewStats({ stats = [] }) {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr 1fr", md: "repeat(4, 1fr)" },
        gap: 1.5,
      }}
    >
      {stats.map((item) => (
        <Paper
          key={item.key}
          elevation={0}
          sx={{
            borderRadius: "20px",
            p: 2,
            border: "1px solid #e6edf5",
            backgroundColor: "#fff",
            boxShadow: "0 10px 24px rgba(15, 23, 42, 0.05)",
          }}
        >
          <Typography variant="body2" sx={{ color: "#74839a" }}>
            {item.label}
          </Typography>
          <Typography variant="h4" sx={{ mt: 0.6, fontWeight: 800, color: "#13233d" }}>
            {item.value}
          </Typography>
          <Typography variant="caption" sx={{ display: "block", mt: 0.75, color: "#7f8da3" }}>
            {item.context}
          </Typography>
        </Paper>
      ))}
    </Box>
  );
}
